import React, { Fragment } from 'react'

import AmenityForm from '@pages/admin/amenity-setup/form'
import AmenityList from '@pages/admin/amenity-setup/list'
import Column from '@components/column'
import Title from '@components/title'

const Amenity = () => {
  return (
    <Fragment>
      <Column gap={10}>
        <Title textone={'Amenity'} texttwo={'Setup'} />
        <AmenityForm />
        <AmenityList />
      </Column>
    </Fragment>
  )
}

export default Amenity
